<template>
  <ResponsiveModal
    v-model:open="open"
    @update:open="(value) => (open = value)"
    :showFooter="false"
  >
    <slot />
    <template #content>
      <div
        class="flex flex-col md:flex-row gap-2 md:gap-1 bg-primary p-4 md:p-0"
      >
        <Button
          variant="secondary"
          type="gray"
          size="md"
          class="w-full"
          icon
          @click="$emit('download', file.file.urls.download)"
        >
          <template #start>
            <Icon name="download" size="xl" />
          </template>
          {{ $t("components.buttons.download") }}
        </Button>
        <DeleteModal
          :id="file.id"
          :title="$t('components.file_details.delete.title')"
          :description="$t('components.file_details.delete.description')"
          @delete="$emit('delete')"
          @cancel="$emit('cancel')"
        >
          <Button class="w-full" variant="primary" type="destructive" size="xl">
            <template #start>
              <Icon name="delete" size="xl" />
            </template>
            {{ $t("components.buttons.delete") }}
          </Button>
        </DeleteModal>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref } from "vue";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { DeleteModal } from "@/SharedComponents/Modals";

const open = ref(false);

defineEmits(["download"]);

defineProps({
  file: { type: Object, required: true },
});
</script>
